import { render } from "./SiteHeaderLogotype.vue?vue&type=template&id=fad0eba4"
const script = {}

import "./SiteHeaderLogotype.vue?vue&type=style&index=0&id=fad0eba4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__